/**
 * The role a refused request needed. A role-gated endpoint answers 403
 * `ROLE_NOT_ACTIVE` with `data.role` when the user holds that role but another
 * one is active. The API client reports that refusal to the auth store, which
 * records the role here so a switch prompt can offer to switch to it.
 */

import type { UserType } from "@shared/types";
import { create } from "zustand";

interface RoleNotActiveState {
	/** The role the last refused request needed, until cleared. */
	role: UserType | null;
	raise: (role: UserType) => void;
	clear: () => void;
}

export const useRoleNotActiveStore = create<RoleNotActiveState>((set) => ({
	role: null,
	raise: (role) => set({ role }),
	clear: () => set({ role: null }),
}));
